<template>
  <vs-popup class="create-product-order-waste-pop-up"
            id="popup"
            :title="`CREATE PRODUCT ORDER WASTE - ${formulation_code}`"
            @close="open = false"
            :active.sync="open"
            :buttons-hidden="true">
    <vx-card no-shadow>

      <h5 class="mb-2">Work orders</h5>


      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(onClickCreateSite)" autocomplete="off">

        <vs-table :onlyClickCheckbox="true" stripe class="mb-8" multiple v-model="selected_work_orders" :data="work_orders">

        <template slot="thead">
          <vs-th width="15%" >CODE</vs-th>
          <vs-th width="20%" >STATUS</vs-th>
          <vs-th width="20%" >QC STATUS</vs-th>
          <vs-th width="15%" >TOTAL WO QUANTITY (KG)</vs-th>
          <vs-th width="15%" >TOTAL CREATED WASTE QUANTITY (KG)</vs-th>
          <vs-th width="15%" >SELECTED QUANTITY (KG)</vs-th>
        </template>

        <template slot-scope="{data}">
          <vs-tr v-if="data[indextr].remaining_quantity !== 0" :data="tr" :key="indextr" v-for="(tr, indextr) in data">

            <vs-td :data="data[indextr].work_order_code">
              {{ data[indextr].work_order_code  }}
            </vs-td>

            <vs-td :data="data[indextr].status">
              {{ data[indextr].status  }}
            </vs-td>

            <vs-td :data="data[indextr].qc_status">
              {{ data[indextr].qc_status  }}
            </vs-td>

            <vs-td :data="data[indextr].completed_quantity">
              {{ Number(data[indextr].completed_quantity).toFixed(2) }}
            </vs-td>

            <vs-td :data="data[indextr].created_waste_quantity">
              {{ Number(data[indextr].created_waste_quantity).toFixed(2) }}
            </vs-td>

            <vs-td :data="data[indextr].selected_qty">
              <ValidationProvider :vid="indextr+'selected_qty'" :name="indextr+'selected_qty'" :rules="'required|min_qty:'+data[indextr].remaining_quantity" v-slot="{ errors }">
                <vs-input type="text" v-model="data[indextr].selected_qty" class="w-full"
                          :name="indextr+'selected_qty'" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x"
                          val-icon-pack="feather"/>
              </ValidationProvider>
            </vs-td>

          </vs-tr>
        </template>
      </vs-table>


          <!-- Save & Reset Button -->
          <div class="flex flex-wrap items-center justify-end mt-8">
            <vs-button :disabled="selected_work_orders.length === 0" button="submit" class="ml-auto mt-2">Create</vs-button>
            <vs-button @click="open = false" class="ml-4 mt-2" type="border" color="warning">Close</vs-button>
          </div>
        </form>
      </ValidationObserver>
    </vx-card>
  </vs-popup>
</template>

<script>
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  const CustomerRepository = RepositoryFactory.get('customer')
  const CourierRepository = RepositoryFactory.get('courier')
  const InventoryRepository = RepositoryFactory.get('inventory');
  const DropDownRepository = RepositoryFactory.get('drop_down')

  import vSelect from 'vue-select'
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'

  import flatPickr from 'vue-flatpickr-component'
  import 'flatpickr/dist/flatpickr.css'

  function initialState() {
    return {
      open: false,
      createForm: {
        address: {}
      },
      id: '',
      selected: [],
      product_order_items: [],
      courier_suppliers: [],
      countryCodes: [],
      customerUsers: [],
      item_id: '',
      work_orders: [],
      selected_work_orders: [],
      formulation_code: '',
      product_item_waste: []
    }
  }

export default {
  name: 'CreateProductWastePopUp',
  data () {
    return initialState()
  },
  methods:{
    async openPopup (item_id, formulation_code,  work_orders, product_item_waste = []) {
      try {
        Object.assign(this.$data, initialState())

        this.item_id = item_id
        this.work_orders = work_orders.map((x) => {
          // calculate total created waste qty
          const waste_items = product_item_waste.filter((n) => x.id === n.work_order_id)
          x.created_waste_quantity = waste_items.reduce((a, b) => a + Number(b.quantity), 0)
          x.remaining_quantity = Number(x.completed_quantity) - Number(x.created_waste_quantity)
          x.selected_qty = x.remaining_quantity
          return x;
        })
        this.formulation_code = formulation_code
        this.product_item_waste = product_item_waste
        // await this.getProductOrderDetails()
        // await this.fetchApprovedCourierShipments()
        this.open = true;
      } catch (error) {

      }
    },

    async getProductOrderDetails() {
      await this.$vs.loading()
      try {
        const {data} = (await CustomerRepository.getCustomerProductOrder(this.id)).data
        this.product_order_items = data.formulation_items.map((n) => {
          const qty = Number(n.quantity).toFixed(2)
          const already_shipped_qty = n.courier_shipments.reduce((a, b) => a + Number(b.quantity), 0)
          n.quantity = qty - Number(already_shipped_qty).toFixed(2)
          n.selected_qty = n.quantity
          return n
        }).filter((x) => Number(x.quantity) > 0)
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close()
      this.dataLoaded = true
    },

    async onClickCreateSite () {
      const vue = this;
      this.$vs.loading()
       try {
         let payload = {
           customer_product_order_item_id: this.item_id,
           items: this.selected_work_orders.map((n) => {
             return { work_order_id: n.id, quantity: Number(n.selected_qty).toFixed(3) }
           })
         }
         await InventoryRepository.createProductWaste(payload)
         this.showSuccessMessage('Product order waste created successfully')
         await vue.$parent.refreshItems()
         this.open = false;
       }catch (e) {
         this.$vs.loading.close()
         this.convertAndNotifyError(e)
       }
      this.$vs.loading.close()
    },
    async fetchApprovedCourierShipments() {
      this.$vs.loading()
      const {data} = await DropDownRepository.getApprovedCourierList()
      this.courier_suppliers =  data.data
      this.$vs.loading.close()
    }
  },
  async mounted () {

  },
  components: {
    'v-select': vSelect,
    flatPickr,
  },
  mixins: [SuccessMessage, ErrorMessages],
}
</script>

<style scoped>
  .create-product-order-waste-pop-up >>> .vs-popup {
    /*min-height: 50% !important;*/
    min-width: 70% !important;
  }

</style>
